import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MEETING_LOCATIONS = ["قاعة الاجتماعات", "مكتب الإرشاد الطلابي", "مركز مصادر التعلم", "الفصل الدراسي", "مكان آخر داخل المدرسة"];
export const MEETING_TIMES = Array.from({ length: 21 }, (_, index) => {
  const minutes = 7 * 60 + index * 30;
  return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
});
export const MEETING_STATUSES = [
  { value: "scheduled", label: "مجدول" },
  { value: "completed", label: "منعقد" },
  { value: "postponed", label: "مؤجل" },
];
export const choiceValues = (value) => Array.isArray(value) ? value : value ? [value] : [];
export const choiceText = (value) => choiceValues(value).join("، ");

export function MeetingSelect({ label, value, options, onChange }) {
  const choices = [...new Set([...options, ...(value ? [value] : [])])];
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger aria-label={label}><SelectValue placeholder="اختر من القائمة" /></SelectTrigger>
        <SelectContent>{choices.map((item) => <SelectItem key={item} value={item}>{item}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}

export function MultiChoice({ label, options, value, onChange, emptyText }) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-semibold text-[#34483b]">{label}</legend>
      {options.length ? (
        <div className="grid max-h-52 gap-2 overflow-y-auto rounded-xl border border-[#e3eae5] bg-[#f7faf8] p-3 sm:grid-cols-2">
          {options.map((option) => (
            <label key={option.value} className="flex cursor-pointer items-center gap-2 rounded-lg bg-white px-3 py-2 text-sm text-[#56655c]">
              <input type="checkbox" checked={value.includes(option.value)} onChange={() => onChange(value.includes(option.value) ? value.filter((item) => item !== option.value) : [...value, option.value])} className="accent-[#27624d]" />
              <span className="min-w-0 flex-1 whitespace-pre-wrap">{option.label}</span>
            </label>
          ))}
        </div>
      ) : <p className="rounded-xl bg-[#f7faf8] p-3 text-sm text-[#68776e]">{emptyText || "لا توجد خيارات متاحة."}</p>}
    </fieldset>
  );
}
